import { Component, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {
    constructor(private router: Router) {
        router.events.subscribe((event) => (event instanceof NavigationEnd) && this.handleRouteChange());
    }
    contactType: string = localStorage.getItem('contactType');
    membershipLevel: string = localStorage.getItem('membershipLevel');
    canViewAds = true;

    ngOnInit() {
        this.handleRouteChange();
    }

    handleRouteChange = () => {
        this.contactType = localStorage.getItem('contactType');
        this.membershipLevel = localStorage.getItem('membershipLevel');
        this.canViewAds = true;
        switch (this.membershipLevel) {
            case "Gold":
            case "Silver":
            case "Startup":
                this.canViewAds = false;
        }
    }


}
